<div class="container-fluid h-custom">
    <div class="row mt-4 mb-4">
        <div class="col-12">
            <button type="button" class="btn btn-primary text-white" (click)="getAllProducts()">Get All Products</button>
        </div>
    </div>
    <div class="row mt-2 mb-2" *ngFor="let product of allProductsData">
        <div class="col-12">{{ product }}</div>
    </div>
</div>
